import { refreshWithParamsAsQuery } from '@/routers';
export function useRefreshWithParams(params, query) {
    return refreshWithParamsAsQuery(params, query);
}
